var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWidgetGauge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 21.261,
    viewBox: "0 0 32 21.261",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M13,21.76a2.951,2.951,0,0,0,1.171,4.371,2.949,2.949,0,0,0,4.371-1.171c1.1-1.912,8.075-18.984,7.469-19.334S14.107,19.847,13,21.76ZM16,9.6a12.041,12.041,0,0,1,2.05.174c.7-.878,1.485-1.846,2.248-2.765A15.446,15.446,0,0,0,16,6.4C7.029,6.4,0,13.965,0,23.625c0,.594.026,1.187.078,1.765A1.6,1.6,0,1,0,3.265,25.1c-.043-.483-.066-.984-.066-1.48C3.2,15.759,8.821,9.6,16,9.6Zm11.55,2c-.446,1.2-.918,2.422-1.334,3.478A14.984,14.984,0,0,1,28.8,23.625c0,.506-.024,1.016-.069,1.509a1.6,1.6,0,0,0,1.448,1.741c.048,0,.1.006.147.006a1.6,1.6,0,0,0,1.592-1.456c.053-.592.082-1.2.082-1.8A17.9,17.9,0,0,0,27.55,11.6Z",
    transform: "translate(0 -5.62)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWidgetGauge);
export default __webpack_public_path__ + "static/media/widget-gauge.0a297c6c.svg";
export { ForwardRef as ReactComponent };